import React from 'react'
import Create from '../crud/create'
import fields from './create-fields'
import menuItems from './menuItems'

const defaultResource = {
  member_type: 'institution'
}

const CreateInstitutionMembership = props => {
  return (
    <Create
// @ts-ignore
      title='Create Institution Membership'
      fields={fields}
      apiPath='admin/memberships'
      successRedirectPath={resource => `/membership/institution-memberships/${resource.id}/edit`}
      buildMenuItems={menuItems}
      resource={defaultResource}
    />
  )
}

export default CreateInstitutionMembership
